module.exports = __webpack_public_path__ + "static/media/iphone_11pro_gold_airpods.2129eb5f.png";